import Pro from 'promise';
import {message} from 'antd';
//import Storage from '../tool/Storage';
import HttpUtil from '../tool/http';

export const getAppDatas = paramsData => {
  //请求参数
  // let uri = 'https://www.e-cloudstore.com/v1.1/app?';
  let uri = `${window.server}/v1.1/app?`;
  for (let i in paramsData) {
    uri += i + '=' + paramsData[i] + '&';
  }
  // 定义请求body信息
  const body = paramsData;
  // 获取请求实体
  const httpUtil = new HttpUtil();
  const request = httpUtil.getGetRequest(uri);

  //调用请求
  return new Pro(function(resolve,reject) {
   // paramsData.access_token = Storage.getAccessToken();
    fetch(request).then(response => {
      return response.json();
    }).then(data => {
      resolve(data);
    }).catch(error =>{
      // message.error(error);
      reject(error);
    })
  });
}

export const specifyList = paramsData => {
  //请求参数
  // let uri = 'https://www.e-cloudstore.com/v1.1/app?';
  let uri = `${window.server}/v5/ecode/specifyList?`;
  for (let i in paramsData) {
    uri += i + '=' + paramsData[i] + '&';
  }
  // 定义请求body信息
  const body = paramsData;
  // 获取请求实体
  const httpUtil = new HttpUtil();
  const request = httpUtil.getGetRequest(uri);

  //调用请求
  return new Pro(function(resolve,reject) {
   // paramsData.access_token = Storage.getAccessToken();
    fetch(request).then(response => {
      return response.json();
    }).then(data => {
      resolve(data);
    }).catch(error =>{
      // message.error(error);
      reject(error);
    })
  });
}

export const specifyApp = paramsData => {
  //请求参数
  // let uri = 'https://www.e-cloudstore.com/v1.1/app?';
  let uri = `${window.server}/v1.1/app?`;
  for (let i in paramsData) {
    uri += i + '=' + paramsData[i] + '&';
  }
  // 定义请求body信息
  const body = paramsData;
  // 获取请求实体
  const httpUtil = new HttpUtil();
  const request = httpUtil.getGetRequest(uri);

  //调用请求
  return new Pro(function(resolve,reject) {
   // paramsData.access_token = Storage.getAccessToken();
    fetch(request).then(response => {
      return response.json();
    }).then(data => {
      resolve(data);
    }).catch(error =>{
      // message.error(error);
      reject(error);
    })
  });
}

export const getCaseDatas = paramsData => {
  //请求参数
  // let uri = 'https://www.e-cloudstore.com/v1.1/app?';
  let uri = `${window.server}/v5/ecode/specifyList?`;
  for (let i in paramsData) {
    uri += i + '=' + paramsData[i] + '&';
  }
  // 定义请求body信息
  const body = paramsData;
  // 获取请求实体
  const httpUtil = new HttpUtil();
  const request = httpUtil.getGetRequest(uri);

  //调用请求
  return new Pro(function(resolve,reject) {
    // paramsData.access_token = Storage.getAccessToken();
    fetch(request).then(response => {
      return response.json();
    }).then(data => {
      resolve(data);
    }).catch(error =>{
      // message.error(error);
      reject(error);
    })
  });
}

export const getAllTags = paramsData => {
  //请求参数
  // let uri = 'https://www.e-cloudstore.com/v1.1/app?';
  let uri = `${window.server}/v5/ecode/allTags`;
  
  // 获取请求实体
  const httpUtil = new HttpUtil();
  const request = httpUtil.getPostRequest(uri, paramsData);

  //调用请求
  return new Pro(function(resolve,reject) {
    // paramsData.access_token = Storage.getAccessToken();
    fetch(request).then(response => {
      return response.json();
    }).then(data => {
      resolve(data);
    }).catch(error =>{
      // message.error(error);
      reject(error);
    })
  });
}

export const findReadme = paramsData => {
  //请求参数
  // let uri = 'https://www.e-cloudstore.com/v1.1/app?';
  let uri = `${window.server}/v5/ecode/findReadme?`;
  for (let i in paramsData) {
    uri += i + '=' + paramsData[i] + '&';
  }
  
  // 定义请求body信息
  const body = paramsData;
  // 获取请求实体
  const httpUtil = new HttpUtil();
  const request = httpUtil.getGetRequest(uri);

  //调用请求
  return new Pro(function(resolve,reject) {
    // paramsData.access_token = Storage.getAccessToken();
    fetch(request).then(response => {
      return response.json();
    }).then(data => {
      resolve(data);
    }).catch(error =>{
      // message.error(error);
      reject(error);
    })
  });
}



// WEBPACK FOOTER //
// ./src/api/list.js